import React from 'react';
import { SeriesColorPicker } from '../ColorPicker/ColorPicker';
import { SeriesIcon } from './SeriesIcon';
/**
 * @internal
 */
export var VizLegendSeriesIcon = function (_a) {
    var disabled = _a.disabled, color = _a.color, onColorChange = _a.onColorChange;
    return disabled ? (React.createElement(SeriesIcon, { color: color })) : (React.createElement(SeriesColorPicker, { color: color, onChange: onColorChange, enableNamedColors: true }, function (_a) {
        var ref = _a.ref, showColorPicker = _a.showColorPicker, hideColorPicker = _a.hideColorPicker;
        return (React.createElement(SeriesIcon, { color: color, className: "pointer", ref: ref, onClick: showColorPicker, onMouseLeave: hideColorPicker }));
    }));
};
VizLegendSeriesIcon.displayName = 'VizLegendSeriesIcon';
//# sourceMappingURL=VizLegendSeriesIcon.js.map